export default {
    case(timeTakenMs) {
        this.time({
            name: 'custom_time_case_taken',
            value: timeTakenMs,
            event_label: 'Time case taken',
            event_category: 'Case',
        })
    },
};
